export const __APP_NAME__ = "Smart Exchange"